import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";

const ReservacionesPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])

  const eliminarItem = (id) => {
    console.log('eliminarItem', id);
    setIsLoading(true);
    try {
      fetch("/p_sucursal",{
        method: "DELETE",
        headers:{
          "Content-Type": "application/json",
        },
        body: JSON.stringify({id})
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setDatos([])
        cargarDatos();
      });
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const [datosTabla] = useState({
    titulo: "Reservaciones",
    ruta: "/sucursal",
    esAgregar: true,
    esEditar: false,
    esEliminar: false,
    eliminar: eliminarItem,
    configTable: configTable
  })

  const [cabecera] = useState([
    { title: "ID", key: "ID_RES" },
    { title: "NOMBRE", key: "NOMBRE_RES" },
    { title: "CORREO", key: "EMAIL_RES" },
    { title: "TELEFONO", key: "TELEFONO_RES" },
    { title: "# DE PERSONAS", key: "NUM_PERSONAS_RES" },
    { title: "FECHA", key: "FECHA_RES" },
    { title: "HORA", key: "HORA_RES" },
    { title: "COMENTARIOS", key: "COMENTARIOS_RES" },
    { title: "FECHA ALTA", key: "FECHA_ALTA_RES", isDate: true },
  ]);

  const cargarDatos = async () => {
    try {
      fetch("/p_reservaciones",{
        method: "GET",
        headers:{
          "Content-Type": "application/json",
        }
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if(data.status === 1){
          setDatos(data.data);
        }
        setIsLoading(false);
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  return (
    <>
      <MasterLayout>
        { isLoading ? <Loader /> : <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/> }
      </MasterLayout>
    </>
  );
};

export default ReservacionesPage;